<template>
  <k-dialog
    @close="cancel"
    :max-width="400"
    :title="action"
    :dataSourceArray="dataSourceArray"
    :selectedIdentity="selectedIdentity"
    :selectedTenant="selectedTenant"
  >
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
         <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
             External Provider :
          </label>
          <div class="col-sm-9">
            <select class="form-control"  
             v-model="providerInEdit.externalProviderID"
             required
            >
            <option v-for="provider in providers" :key="provider.id" :value="provider.id">
              {{provider.displayName}}
            </option>
            </select>
            
          </div>
        </div>
          <div v-if="providerInEdit.externalProviderID">
          <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">Type:</label>

          <div class="col-sm-9 text-left">
            <p class="form-control">
              {{ providerType }}
            </p>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">Fields:</label>
          <div class="col-sm-9 text-left">
            <p class="form-control">
              {{ providerFields }}
            </p>
          </div>
        </div>
          </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">Configuration:</label>

          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'fieldValues'"
              :placeholder="fieldValues"
              v-model="providerInEdit.fieldValues"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>
      
      </div>
      
      <input type="submit" id="submit-form" class="d-none" />
    </form>

    <div class="d-flex ">
      <button class="k-button col-6" @click="cancel" >Cancel</button>
      <label class="k-button k-primary col-6 mb-0" for="submit-form" tabindex="0"
        >Save</label
      >
    </div>
  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";
import { oidcSettings } from "../../services/store";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.data";
export default {
  components: {
    "k-input": Input,
    numerictextbox: NumericTextBox,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,

  },
  props: {
    dataItem: Object,
    dialogTitle: String,
    dataSourceArray: Array,
    selectedIdentity: Object,
    selectedTenant: Object,
    providers:Array,
  },
  data: function () {
    return {
      fieldValues:'{"ExternalClientID":"xxx","ExternalClientSecret":"xxxx"}',
      providerInEdit: {
        fieldValues:"",
        externalProviderID:""
      },
      base_url: undefined,
      action: "",
      messages: {
        checked: "Yes",
        unchecked: "No",
      },
    };
  },
  created: function () {
    this.action = this.$props.dialogTitle;
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";

    console.log(this.$props.dialogTitle);
    if (this.$props.dataItem) {
      this.providerInEdit = this.$props.dataItem;
      console.log(this.providerInEdit);
    } else {
      this.providerInEdit = {
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        roles: [],
        isActive: false,
        tenantName: "",
      };
    }
  },
  mounted: function () {
  },

  computed: {
    providerFields(){
      if(this.providerInEdit.externalProviderID !=null){
          const index = this.providers.findIndex((p) => p.id === this.providerInEdit.externalProviderID);
          return this.providers[index].fields;
      }
    },
    providerType(){
      if(this.providerInEdit.externalProviderID !=null){
          const index = this.providers.findIndex((p) => p.id === this.providerInEdit.externalProviderID);
          return this.providers[index].type;
      }
    },
  },

  methods: {
    
    onSelectTenant() {
      console.log("change",this.providerInEdit.tenantID);
    },
    onChange() {
      console.log("changed");
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
        this.$emit("save");
    },
  },
};
</script>
<style scoped>
</style>